import React from "react";

import { useTranslation } from "react-i18next";

import Button, { Color } from "../../../../Form/Button";
import { DefaultTooltip } from "../../../Tooltip";
import useStyles from "../../styles";
import { UploadCSVFileHandles } from "../UploadCSVCartons";

interface Props {
  show: boolean;
  disabled?: boolean;
  loading?: boolean;
  tooltip?: React.ReactNode;
  tooltipSlotProps?: React.ComponentProps<typeof DefaultTooltip>["slotProps"];
  uploadCSVRef: React.RefObject<UploadCSVFileHandles>;
}

const UploadCSVButton = (props: Props) => {
  const { show, loading, disabled, tooltip, tooltipSlotProps, uploadCSVRef } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const onClick = () => {
    if (disabled) return;

    uploadCSVRef.current?.open();
  };

  if (!show) return null;

  return (
    <DefaultTooltip title={tooltip ?? translate("uploadCsv")} slotProps={tooltipSlotProps}>
      <div>
        <Button
          loading={loading}
          customColor={Color.SECONDARY_OUTLINED}
          onClick={onClick}
          disabled={disabled}
        >
          <span className={classes.buttonText}>{translate("uploadCsv")}</span>
        </Button>
      </div>
    </DefaultTooltip>
  );
};

export default UploadCSVButton;
